import * as React from 'react'

export function Check(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M20.7072 6.70718L9.00008 18.4143L3.29297 12.7072L4.70718 11.293L9.00008 15.5859L19.293 5.29297L20.7072 6.70718Z"
                fill="currentColor"
            />
        </svg>
    )
}
